var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { WMLogger } from '@mobilize/logging';
import { ModelResolver } from '../../Core';
import { ErrorCodes, ExceptionHandlerClass } from '../../System/Aop';
var ModelResolverV5 = (function (_super) {
    __extends(ModelResolverV5, _super);
    function ModelResolverV5() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelResolverV5.prototype.resolveAdded = function (projections) {
        var _this = this;
        this.myIsSynchronizing = true;
        if (projections) {
            var newModels = projections.map(function (projection) { return _this.modelFactory.create(projection); });
            this.addNewModels(newModels);
            var behaviors = this.getBehaviors();
            this.applyBehaviors(behaviors, newModels);
        }
        this.myIsSynchronizing = false;
    };
    ModelResolverV5.prototype.resolveChanged = function (projections) {
        this.myIsSynchronizing = true;
        if (projections) {
            var updatedModels = this.updateModels(projections);
            var behaviors = this.getBehaviors();
            behaviors.evt = [];
            this.applyBehaviors(behaviors, updatedModels);
        }
        this.myIsSynchronizing = false;
    };
    ModelResolverV5.prototype.resolveRemoved = function (removedIds) {
        var _this = this;
        this.myIsSynchronizing = true;
        if (removedIds) {
            removedIds.forEach(function (id) {
                _this.detachReference(id);
                _this.buffer.deleteCascade(id);
            });
        }
        this.myIsSynchronizing = false;
    };
    ModelResolverV5.prototype.addNewModels = function (newModels) {
        var _this = this;
        newModels.forEach(function (item) {
            if (item.UniqueID && item.UniqueID.length > 0) {
                if (!_this.buffer.exists(item)) {
                    _this.buffer.add(item);
                }
                else {
                    WMLogger.instance().error("New model with Id ".concat(item.UniqueID, " already exists."));
                }
            }
        });
    };
    ModelResolverV5.prototype.updateModels = function (projections) {
        var updatedModels = [];
        for (var _i = 0, projections_1 = projections; _i < projections_1.length; _i++) {
            var projection = projections_1[_i];
            var model = this.buffer.getModel(projection.Id);
            if (model) {
                model.updateModel(projection);
                if (projection.EventChanges) {
                    model.eventChanges = projection.EventChanges;
                }
                if (projection.Style) {
                    model.stylePivot = projection.Style;
                }
                updatedModels.push(model);
            }
            else {
                console.error('This models is not in the buffer. Please check the Backend response in the removed area.');
            }
        }
        return updatedModels;
    };
    ModelResolverV5.prototype.detachReference = function (id) {
        var model = this.buffer.getModel(id);
        if (model) {
            var parentRefs = model.referencedBy;
            for (var parentId in parentRefs) {
                if (parentRefs.hasOwnProperty(parentId)) {
                    var parent_1 = this.buffer.getModel(parentId);
                    if (parent_1) {
                        parent_1.removeReference(parentRefs[parentId]);
                    }
                }
            }
        }
    };
    ModelResolverV5 = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore)
    ], ModelResolverV5);
    return ModelResolverV5;
}(ModelResolver));
export { ModelResolverV5 };
